/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import "../../styles/time_table_management.css";
import applicationstagesLabels from '../labels/applicationstages_en.json'
import challanLabels from '../../../challanmanagement/Labels/challan_en.json'
import dayjs from "dayjs";
import { fromUTCDate, toUTCDate } from "../../../helpers/Datetime";
import { useForm, Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import { downloadUploadedInterviewPtLetterFile, getInterviewPtLetterDropdownValuesAPI } from "../actions/applicationStagesAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

const DownloadInterviewLetterModal = (props) => {
    const dispatch = useDispatch();
    const { control } = useForm({ mode: "onChange" });
    const { getInterviewPtLetterDropdownValues } = useSelector((state) => state.applicationManagementReducer, shallowEqual);

    let scheduleType = props.scheduleType ? props.scheduleType : '';
    let advId = props.advId ? props.advId : '';
    let postid = props.postid ? props.postid : '';

    let [interviewDate, setInterviewDate] = useState('');
    let [interviewSession, setInterviewSession] = useState('');
    let [interviewCommittee, setInterviewCommittee] = useState('');
    let [interviewCenter, setInterviewCenter] = useState('');
    let [interviewPhase, setInterviewPhase] = useState('');

    useEffect(() => {
        dispatch(getInterviewPtLetterDropdownValuesAPI(advId, scheduleType, postid))
    }, []);

    const handleDownloadInterviewLetterCsvClick = () => {
        setInterviewDate('');
        setInterviewSession('');
        setInterviewCommittee('');
        setInterviewCenter('');
        setInterviewPhase('');
        let date = interviewDate ? dayjs(interviewDate).format(applicationstagesLabels.DATE_FORMAT_LABEL) : '';
        dispatch(downloadUploadedInterviewPtLetterFile(advId, scheduleType, postid, interviewCenter, date, interviewSession, interviewPhase, interviewCommittee))
    };

    const cancelModal = () => {
        props.setOpenDonwloadInterviewLetterCsvModal(false);
        props.setInterviewPtLettertype('');
        props.setInterviewPtLetterPostId('');
    };

    return (
        <div>
            <Modal size="xl" show={props.openDonwloadInterviewLetterCsvModal} onHide={cancelModal} aria-labelledby="example-modal-sizes-title-lg" backdrop='static'>
                <Modal.Header  className="d-flex justify-content-between align-items-center logout_heading">
                    <Modal.Title></Modal.Title>
                      <button
                        type="button"
                        className="ms-auto logout_close"
                        aria-label="Close"
                        onClick={cancelModal}
                    >X</button>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className='col-md-4 mt-2'>
                            <label className="fw-bold">{applicationstagesLabels.INTERVIEW_DATE}</label>
                            <Controller
                                name="interviewDate"
                                key={interviewDate && interviewDate ? "interviewDate" : "interviewDate1"}
                                defaultValue={interviewDate && interviewDate ? dayjs(interviewDate).toDate() : ""}
                                control={control}
                                render={({ onChange, value }) => (
                                    <div className="date-picker-container">
                                        <DatePicker
                                            selected={interviewDate ? fromUTCDate(value) : ''}
                                            showMonthDropdown
                                            showYearDropdown
                                            placeholderText={applicationstagesLabels.DATE_FORMAT}
                                            dateFormat={applicationstagesLabels.SMALL_SIZE_DATE_FORMAT}
                                            onChange={(e) => {
                                                setInterviewDate(toUTCDate(e));
                                                onChange(toUTCDate(e));
                                            }}
                                            className="form-control bg-color ps-2"
                                            showIcon
                                            icon={
                                            <img src="/icons/calender.png" className="date-picker-icon"></img>
                                            }                                        
                                        />
                                    </div>
                                )}
                            />
                        </div>
                        <div className="col-md-4 mt-2">
                            <label className="fw-bold">{applicationstagesLabels.INTERVIEW_SESSION}</label>
                            <div className="input-group bg-color">
                                <select
                                    className="form-select bg-color"
                                    name="interviewSession"
                                    value={interviewSession}
                                    onInput={(e) => {
                                        setInterviewSession(e.target.value);
                                    }}
                                >
                                    <option key={0} value="">{applicationstagesLabels.COMBO_SELECT}</option>
                                    {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.sessionList &&
                                        getInterviewPtLetterDropdownValues.sessionList.length > 0 &&
                                        getInterviewPtLetterDropdownValues.sessionList.map((element, index) => (
                                            <option key={index} value={element.id}>
                                                {element.label}
                                            </option>
                                        ))}
                                </select>
                            </div>

                        </div>
                        <div className="col-md-4 mt-2">
                            <label className="fw-bold">{applicationstagesLabels.INTERVIEW_COMMITTEE}</label>
                                <div className="input-group bg-color">
                                    <select
                                        className="form-select bg-color"
                                        name="interviewCommittee"
                                        value={interviewCommittee}
                                        onInput={(e) => {
                                            setInterviewCommittee(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">{applicationstagesLabels.COMBO_SELECT}</option>
                                        {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.committeeList &&
                                            getInterviewPtLetterDropdownValues.committeeList.length > 0 &&
                                            getInterviewPtLetterDropdownValues.committeeList.map((element, index) => (
                                                <option key={index} value={element.id}>
                                                    {element.label}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <label className="fw-bold">{applicationstagesLabels.INTERVIEW_CENTER}</label>
                                <div className="input-group bg-color">         
                                    <select
                                        className="form-select bg-color"
                                        name="interviewCenter"
                                        value={interviewCenter}
                                        onInput={(e) => {
                                            setInterviewCenter(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">{applicationstagesLabels.COMBO_SELECT}</option>
                                        {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.examCenterList &&
                                            getInterviewPtLetterDropdownValues.examCenterList.length > 0 &&
                                            getInterviewPtLetterDropdownValues.examCenterList.map((element, index) => (
                                                <option key={index} value={element.id}>
                                                    {element.name}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                        </div>
                        <div className="col-md-4 mt-2">
                            <label className="fw-bold">{applicationstagesLabels.INTERVIEW_PHASE}</label>
                                <div className="input-group bg-color">
                                    <select
                                        className="form-select bg-color"
                                        name="interviewPhase"
                                        value={interviewPhase}
                                        onInput={(e) => {
                                            setInterviewPhase(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">{applicationstagesLabels.COMBO_SELECT}</option>
                                        {getInterviewPtLetterDropdownValues && getInterviewPtLetterDropdownValues.phaseList &&
                                            getInterviewPtLetterDropdownValues.phaseList.length > 0 &&
                                            getInterviewPtLetterDropdownValues.phaseList.map((element, index) => (
                                                <option key={index} value={element.id}>
                                                    {element.label}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                        </div>
                        <div className='col-md-4 mt-2'>
                            <button
                                className="btn btn-sm btn-primary cursor-pointer ms-3 mt27"
                                onClick={handleDownloadInterviewLetterCsvClick}
                            >
                                {applicationstagesLabels.DOWNLOAD_OBJECTION_REPORT}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={cancelModal}>{challanLabels.CANCEL}</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DownloadInterviewLetterModal;